import { useMutation } from '@apollo/client'
import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import {
  ItAssetDetailsQuery,
  ItAssetsTableQuery,
  MarkItAssetAsUnderMaintenanceDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type Asset =
  | ItAssetsTableQuery['itManagement']['itAssetsConnection']['nodes'][number]
  | ItAssetDetailsQuery['itManagement']['itAsset']

interface Props {
  asset: Asset
  onClose: () => void
}

export const ItAssetMaintenanceModal = ({ asset, onClose }: Props) => {
  const [setToMaintenaceItAsset, { loading: deleteLoading }] = useMutation(
    MarkItAssetAsUnderMaintenanceDocument
  )

  const handleSetMaintenance = async () => {
    if (!asset) return

    try {
      await setToMaintenaceItAsset({
        variables: {
          id: asset.id,
          itAssetModelId: String(asset.itAssetModel?.id ?? ''),
          serialNumber: String(asset.serialNumber ?? ''),
        },
        refetchQueries: ['ItAssetsTable', 'ItAssetDetails'],
        awaitRefetchQueries: true,
      })
      app.setFlash({
        type: 'correct',
        message: i18n.t('it_management.assets.maintenance_modal.success_message'),
      })
      onClose()
    } catch (error) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('it_management.assets.maintenance_modal.error_message'),
      })
    }
  }

  const assetName = asset
    ? asset.itAssetModel?.brand && asset.itAssetModel?.name
      ? `${asset.itAssetModel.brand} ${asset.itAssetModel.name}`
      : asset.serialNumber || 'Unknown Asset'
    : 'Unknown Asset'

  return (
    <Modal
      title={i18n.t('it_management.assets.maintenance_modal.title')}
      onClose={onClose}
      illustration={'laptop-user'}
      description={i18n.t('it_management.assets.maintenance_modal.description', { assetName })}
      onSubmit={handleSetMaintenance}
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <F0Button
            variant="outline"
            onClick={onClose}
            disabled={deleteLoading}
            label={i18n.t('common.cancel')}
          />

          <F0Button
            type="negative"
            submit
            loading={deleteLoading}
            label={i18n.t('it_management.assets.maintenance_modal.submit')}
          />
        </Box>
      }
    />
  )
}
